// Define some common icons used across the application.
/** @jsxImportSource solid-js */
import { classed } from "#palette/style/index.solid";

export const IconBase = classed.span`
    iconify
    inline-block
    align-middle
    h-6
    w-6
`;

// Icons are defined here to make them a little more
export const Icons = {
  // General icons used across the application.
  Heart: classed(IconBase)`i-ph-heart-duotone`,
  BrokenHeart: classed(IconBase)`i-ph-heart-break-duotone`,
  Escape: classed(IconBase)`i-ph-sign-out`,
  Home: classed(IconBase)`i-ph-house-duotone`,
  UnderConstruction: classed(IconBase)`i-ph-crane-tower-duotone`,
  ChevronUpDown: classed(IconBase)`i-ph-caret-up-down-duotone`,
  ChevronDown: classed(IconBase)`i-ph-caret-down-duotone`,
  Close: classed(IconBase)`i-ph-x-circle-duotone`,
  Edit: classed(IconBase)`i-ph-note-pencil-duotone`,
  OK: classed(IconBase)`i-ph-check-fat-duotone`,
  More: classed(IconBase)`i-ph-dots-three-outline-vertical-duotone`,
  Circle: classed(IconBase)`i-ph-circle-duotone`,
  CircleCheck: classed(IconBase)`i-ph-check-circle-duotone`,
  CircleDots: classed(IconBase)`i-ph-dots-three-circle-duotone`,
  CircleInfo: classed(IconBase)`i-ph-info-duotone`,
  CircleAdd: classed(IconBase)`i-ph-plus-circle-duotone`,
  Bug: classed(IconBase)`i-ph-bug-duotone`,

  // Icons used for messaging, either for broadcast or person-to-person.
  Messaging: {
    Initiate: classed(IconBase)`i-ph-paper-plane-duotone`,
    Allowlist: classed(IconBase)`i-ph-tray-arrow-down-duotone`,
  },

  // Icons used for user management of any sort.
  User: {
    One: classed(IconBase)`i-ph-user-circle-duotone`,
    Group: classed(IconBase)`i-ph-users-three-duotone`,
    Add: classed(IconBase)`i-ph-user-plus-duotone`,
    Settings: classed(IconBase)`i-ph-user-circle-gear-duotone`,
    Consent: classed(IconBase)`i-ph-thumbs-up-duotone`,
    Delete: classed(IconBase)`i-ph-seal-warning-duotone`,

    // Icons used in authentication components.
    Auth: {
      ShowPassword: classed(IconBase)`i-ph-eye-duotone weak`,
      HidePassword: classed(IconBase)`i-ph-eye-slash-duotone weaker`,
      Escape: classed(IconBase)`i-ph-rocket-launch-duotone`,
    },

    Status: {
      Active: classed(IconBase)`i-ph-check-fat-duotone`,
      Deactivated: classed(IconBase)`i-ph-chat-circle-slash-duotone weakest`,
      NeedsActivation: classed(
        IconBase,
      )`i-ph-warning-duotone text-status-error-fg`,
    },
  },

  IncidentLog: classed(IconBase)`i-ph-subtitles-duotone`,
  LegacyRecordForm: classed(IconBase)`i-ph-subtitles-slash-duotone`,
  Resources: classed(IconBase)`i-ph-person-simple-tai-chi-duotone`,
  Question: classed(IconBase)`i-ph-question-duotone`,

  // Icons used when dealing with matching entries.
  Matching: classed(IconBase)`i-ph-graph-duotone`,
  Entries: {
    LanguagePreferenceSet: classed(IconBase)`i-ph-chat-circle-text-duotone`,
    LanguagePreferenceUnknown: classed(
      IconBase,
    )`i-ph-chat-circle-slash duotone weakest`,

    AccomodationsNeeded: classed(IconBase)`i-ph-wheelchair-duotone`,
    AccomodationsUnknown: classed(IconBase)`i-ph-wheelchair-duotone weakest`,
  },

  // Icons used for general navigation purposes.
  Navigation: {
    Forward: classed(IconBase)`i-ph-arrow-right-duotone`,
    Back: classed(IconBase)`i-ph-arrow-left-duotone`,
    Return: classed(IconBase)`i-ph-arrow-bend-double-up-left-duotone`,
  },
};
